export default __webpack_public_path__ + "static/media/school.0f1da7e0.svg";